/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AnimatedButton from '../../../components/Animation/AnimatedButton';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import GlobalContext from '../../../components/Context/GloablContext';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import FilterBtn from '../../../components/Filter';
import MonitorExport from './MonitorExport';
import FilterModal from '../TopBarMonitor/Filter'
import SearchMonitor from './SearchForMonitor';
import { handleAddFilterValues, handleSidebarPrvState } from '../../../redux/systemConfigSlice';
import HelpGuideModal from '../../../components/HelpGuideModal';
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'

const TopBarMonitor = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    AddButton,
    menuBar,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    suggestions,
    setSuggestions,
    optimizedFn,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    toAddScreen,
    isExport,
    snakeToCamelCase,
    handleCheckboxChange,
    setConfirmationState,data,exportUsers,isActivityexport,isIdexport,selected,setSelected,optionRef,viewExportHistory}) => {
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,setIsSideBar,isAdvancedSearchOpen,setIsAdvancedSearchOpen} = useContext(GlobalContext);
    const navigate=useNavigate()
    const dispatch=useDispatch()
    const fileInputRef = useRef(null);
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isChangeStatusOPenxl, setIsChangeStatusOpenxl] = useState(false)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    const ref = useRef()
    const ref2=useRef()

    function generateArray(searchParams, object) {
        const result = {};
      
        const keysToCheck = ['monitor_permission', 'status'];

        for (const key of keysToCheck) {

            if (searchParams[key]) {
                const values = searchParams[key].split(',');
               
                result[key] = values;
                
            } else if (Object.keys(filtervals).length !== 0 &&object?.hasOwnProperty(key)) {
                
                result[key] = object[key];
                
                  
            }
        }
        
      
        return result;
    }
    function getSearchParams() {
        const searchParams = new URLSearchParams(window.location.search);
        const result = {};
      
        searchParams.forEach((value, key) => {
            result[key] = value;
        });
      
        return result;
    }

    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=admin-list-monitor-users');
        } else {
            setQueryParamsadmin('type=admin-list-monitor-users');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
        
      
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })
    useOnClickOutside(ref2, () => {
        setIsChangeStatusOpenxl(false)
    }) 

    const handleOpenFilter = () => {
        if(viewExportHistory!==undefined){
            if((searchParams.get("start_date")!==null||searchParams.get("end_date")!==null)&&!isFilterOpen){
                setFilterValues(filtervals)
            }
            else if(searchParams.get("start_date")===null&&searchParams.get("end_date")===null){
                setFilterValues({
                    "filter_start_date":'',
                    "filter_end_date":'',
                })
            }

        }else{
            const params=getSearchParams()
            const resultArray = generateArray(params, filterValues);
            setFilterValues(resultArray)
            dispatch(handleAddFilterValues(resultArray))  
        }
             
        setIsFilterOpen(!isFilterOpen)
        
    }

    function handleActivateClick(status) {
        if (selectedRows.map((item) => item.name).length > 50) {
            setToastErrorMessage(`You cannot ${status} more than 50 users at once`)
            setIsChangeStatusOpen(false)
            return
        }
        setIsChangeStatusOpen(false)
        if (status === "activate") {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'active', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
        else {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'deactive', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
    }

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
      
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };

    
    return (
        <div className="flex justify-between items-center mb-[14px]">
            <div className='flex'>
                {title!==undefined ?
                    <h1 className="pt-2 self-start text-xl font-normal text-[#000000] xl:min-w-fit">{title}</h1>
                    :
                    pathPlaceholder &&
                    <Link to={path} state={username && path !== '/manage-admin-corporate/' ? [username] : null} className='items-center min-w-fit flex'>
                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                        <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                    </Link>
                }
                {
                    (userType !=='super-admin' && !pathPlaceholder)&&
                    <span   onClick={() => setHelpGuideModel(true)} className=' ml-2   cursor-pointer'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                }
            </div>
        
            <div className={`flex items-center monitoruserheader justify-end relative 2xl:flex-nowrap flex-wrap`}>
                {menuBar && <div className='relative 2xl:mb-0 mb-2.5'>
                    <button id="threedot" className={`rounded-[15px] border border-[#972E4C] w-max px-[13px] py-[10px] hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPen? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                        onClick={() => { setIsChangeStatusOpen(!isChangeStatusOPen),setIsFilterOpen!==undefined&&setIsFilterOpen(false) }}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                    >
                        {
                            isHover || isChangeStatusOPen ? <img src="/images/3dots_white.svg" alt="img" /> : <img src="/images/3_dots_color.svg" alt="img" />

                        }
                    </button>
                    {isChangeStatusOPen && <ul ref={ref} className='px-1.5 py-3 rounded-[6px] absolute top-12 right-5 bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                        <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Change Status</li>
                        <li>
                            <ul>
                                <li>
                                    <AnimatedButton
                                        handleClick={(e) => { handleActivateClick("activate") }}
                                        buttonName={"Activate"}
                                        disabled={(selectedRows?.filter((user)=>user.status==='inactive'))?.map((item)=>item.name).length===0?true:false}
                                        className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user)=>user.status==='inactive'))?.map((item)=>item.name).length===0?'text-[#6e6d6d]':'hover:text-[#008586] text-[#000000] cursor-pointer'} `}
                                    />
                                </li>
                                <li>
                                    <AnimatedButton
                                        handleClick={(e) => { handleActivateClick("deactivate") }}
                                        buttonName={"Deactivate"}
                                        disabled={(selectedRows?.filter((user)=>user.status==='active'))?.map((item)=>item.name).length===0?true:false}
                                        className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user)=>user.status==='active'))?.map((item)=>item.name).length===0?'text-[#706a6a]':'hover:text-[#008586] text-[#000000] cursor-pointer'}  `}
                                    />
                                </li>
                            </ul>
                        </li>
                    </ul>}
                </div>}
                {/* {SearchInput && <SearchMonitor
                    suggestions={suggestions}
                    setSuggestions={setSuggestions}
                    optimizedFn={optimizedFn}
                    SearchPlaceholder={SearchPlaceholder}
                    selected={selected}
                    setSelected={setSelected}
                    snakeToCamelCase={snakeToCamelCase}
                    data={data}
                    searchParams={searchParams}
                    optionRef={optionRef}
                    options={['ID','Username','First Name','Last Name','Status','Email Address','Mobile Number','Main Number','Permissions']}
                />} */}
                {SearchInput && <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 2xl:mb-0 mb-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[13px]">
                    <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                </button>}
                <div className='flex items-center'>
                    
                    {(ApplyFilter !== undefined && ApplyFilter) &&
                    viewExportHistory!==undefined?
                        <FilterBtn
                            isFilterOpen={isFilterOpen}
                            setIsFilterOpen={setIsFilterOpen}
                            handleApplyFilter={handleApplyFilter}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            isFilterOrganization={true}
                            initialState={initialState}
                            isActivityexport={isActivityexport}
                            handleOpenFilter={handleOpenFilter}/>:
                        <FilterModal
                            isFilterOpen={isFilterOpen}
                            setIsFilterOpen={setIsFilterOpen}
                            handleApplyFilter={handleApplyFilter}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            initialState={initialState}
                            handleOpenFilter={handleOpenFilter} 
                            handleCheckboxChange={handleCheckboxChange}
                        />
                    }
                    
                    {(SearchInput||isExport)&&data!==undefined&&data?.data?.length>0&&<div className='2xl:mb-0 mb-2.5'> 
                        
                        <MonitorExport 
                            selectedRows={selectedRows}
                            exportUsers={exportUsers}
                            exportCols={exportCols}
                            setIsFilterOpen={setIsFilterOpen}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            isIdexport={isIdexport}
                            isActivityexport={isActivityexport} username={username} />
                            
                    </div>}
                     
                    {viewExportHistory!==undefined && 
                    <>{<Link to={'/manage-monitor-user/activity_history/export-history'} state={{"target_user_name":searchParams.get("target_user_name")}} >
                        <button type='button'
                            id="view_export_history"
                            className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] 2xl:mb-0 mb-2.5 min-w-max`}>
                            View Export History
                        </button>
                    </Link>}</>}
               
                    {AddButton && 
                    <>{<Link to={toAddScreen} state={{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),"search_mode":searchParams.get("search_mode"),'search':searchParams.get("search")?searchParams.get("search"):''}}>
                        <button type='button'
                            id="Add monitor user"
                            className={`py-2.5 lg:px-4 px-2 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 2xl:mb-0 mb-2.5 w-max 
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                            <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                            <span>{buttonName}</span> 
                        </button>
                    </Link>}</>}
                    {(helpGuideModel && helpguidestatus==="fulfilled") &&
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                    }
                </div>
            </div>
        </div>
    );
}

export default TopBarMonitor;
